import {
  CourseSectionDto,
} from '../../apis/eols-course-crud/eols-course-crud.dtos';
import {
  CrosswalkUserDto,
  UserDto
} from '../../apis/eols-user-management-service/eols-user-management-service.dtos';
import {
  FeatureFlagDto,
  FeatureFlagsGroupedDto
} from '../../apis/eols-features-api/eols-features-api.dtos';
import { AppLinkData } from '../../apis/eols-app-link/eols-app-link.dtos';
import { Messages } from '../../translations/message.models';
import { OsmosisTokenDto } from '../../apis/sherpath-course-management-service/sherpath-course-management-service.dtos';
import {
  ChatDto,
  ChatEntitlementDto,
  ChatEntitlementTypeDto,
  ChatUserRoleDto,
} from '../../apis/nhe-ai-chat-service/nhe-ai-chat-service.dtos';
import { ChatModeType } from '../../pages/ai-chat/ai-chat.constants';

export enum ApiStatus {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  NOT_FOUND = 'NOT_FOUND',
  ERROR = 'ERROR'
}

export type AppState = {
  courseSectionId: string;
  currentCourse: CourseSectionDto;
  evolveUser: CrosswalkUserDto;
  crosswalkApiStatus: ApiStatus;
  featureFlagsGrouped: FeatureFlagsGroupedDto[];
  messages: Messages;
  pendingRequestCount: number;
  userId: string;
  userRole: string;
  eolsUser: UserDto;
  appLinkCookies: {
    token: string;
    linkId: string;
  };
  registeredToken: string;
  appLinkData: AppLinkData;
  abTestFlavors: FeatureFlagDto[];
  osmosisTokenDto: OsmosisTokenDto;
  cookieCheckComplete: boolean;
  ecrId: string; // TODO: make this work,
  tokenIsbns: string;
  selectedIsbnMap: Record<string, boolean>;
  chats: ChatDto[];
  activeChatId: number;
  isLoading: boolean;
  inProgressPostProcessJobIds: number[];
  showLoader: boolean;
  entitlements: Partial<Record<ChatEntitlementTypeDto, ChatEntitlementDto[]>>;
  ipAddress: string;
  isSidebarOpen: boolean;
  isPanelOpen: boolean;
  enableAdminOverride: boolean;
  chatUserRole: ChatUserRoleDto;
  pageContext: string;
  chatModeType: ChatModeType;
}
